import { Button, Empty, Result, Spin } from 'antd';
import React from 'react';

interface StateRendererProps {
  loading: boolean;
  error: string | null;
  empty: boolean;
  emptyMessage?: string;
  emptyIcon?: React.ReactNode;
  onRetry?: () => void;
  children: React.ReactNode;
  className?: string;
}

export default function StateRenderer({
  loading,
  error,
  empty,
  emptyMessage = '暫無資料',
  emptyIcon,
  onRetry,
  children,
  className = 'py-12',
}: StateRendererProps) {
  if (loading) {
    return (
      <div
        className={className}
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <Spin size="large" tip="載入中...">
          <div style={{ padding: 32 }} />
        </Spin>
      </div>
    );
  }

  if (error) {
    return (
      <div className={className}>
        <Result
          status="error"
          title="載入失敗"
          subTitle={error}
          extra={
            onRetry && (
              <Button type="primary" onClick={onRetry}>
                重新載入
              </Button>
            )
          }
        />
      </div>
    );
  }

  if (empty) {
    return (
      <div className={className}>
        <Empty
          image={emptyIcon}
          description={emptyMessage}
          style={{ minHeight: 48 }}
        />
      </div>
    );
  }

  return <>{children}</>;
}
